var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ItemDisplay',{attrs:{"icon":_vm.icon,"action":(item) => _vm.setCarState(item.id, _vm.actionState),"hasAction":_vm.hasAction,"items":_vm.clearedStudents,"modal":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }